import { render, staticRenderFns } from "./wasteGasSp.vue?vue&type=template&id=87908918&scoped=true&"
import script from "./wasteGasSp.vue?vue&type=script&lang=js&"
export * from "./wasteGasSp.vue?vue&type=script&lang=js&"
import style0 from "./wasteGasSp.vue?vue&type=style&index=0&id=87908918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87908918",
  null
  
)

export default component.exports